<template>
  <div>
    <div class="project">
      <el-row>
        <el-col>
          <div class="project-1">
            <div class="project-1-input">
              <el-form inline>
                <el-form-item label="服务类目">
                  <el-input clearable v-model="query.category_name" placeholder="请输入类目名称" @keyup.enter.native="search">
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <el-button style="margin-right: 20px;" v-if="JudgeButton(role_permission,'category/query')" type="primary"
              icon="el-icon-search" @click="search">搜索</el-button>
            <el-button v-if="JudgeButton(role_permission,'category/increase')" type="success" icon="el-icon-circle-plus"
              @click="handleEdit()">新增</el-button>
          </div>
          <div class="project-2" style="width: 60%;" v-loading='loading'>
            <el-table stripe border :data="list">
              <el-table-column align='center' prop="category_name" label="类目名称">
              </el-table-column>
              <el-table-column align='center' prop="add_time" label="创建日期">
              </el-table-column>
              <el-table-column label="操作" align='center'>
                <template slot-scope="scope">
                  <el-button v-if="JudgeButton(role_permission,'category/project')" size="mini" type="primary"
                    @click="$router.push({path: 'category/project', query:{category_id: scope.row.category_id, category_name: scope.row.category_name}})">
                    服务项目</el-button>
                  <el-button v-if="JudgeButton(role_permission,'category/edit')" size="mini" type="primary"
                    @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button v-if="JudgeButton(role_permission,'category/delete')" size="mini" type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
              @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
              :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit"
              layout="total, sizes, prev, pager, next, jumper" :total="query.total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 类目 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%" @close='close'>
      <el-form :model="form" ref='form' :rules="rules">
        <el-form-item label="类目名称" label-width='130px' prop='category_name'>
          <el-input v-model="form.category_name" placeholder="请输入类目" autocomplete="off" :maxlength='15'></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    name: 'project',
    components: {
    },
    props: {},
    data() {
      return {
        loading: true,
        list: [],
        query: {
          category_name: '',
          page_limit: 10,
          page: 1,
          total: 0
        },
        title: '',
        dialogFormVisible: false,
        form: {
          category_id: '',
          category_name: '',
        },
        rules: {
          category_name: [{
            required: true,
            message: '请输入类目名称',
            trigger: 'blur'
          }],
        }
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    mounted() {
      this.loading = true
      if (this.$store.state.cache.cacheCategoryQuery) this.query = this.$store.state.cache.cacheCategoryQuery
      this.getList();
    },
    beforeDestroy() {
      this.$store.commit('CACHE_CATEGORY', this.query)
    },
    methods: {
      search() {
        this.query.page = 1;
        this.loading = true;
        this.getList()
      },
      close() {
        this.$refs['form'].resetFields(); //强制清理表格内容 
        this.dialogFormVisible = false;
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      handleEdit(row) {
        if (row) {
          this.title = '编辑类目'
          this.form.category_name = row.category_name
          this.form.category_id = row.category_id
        } else {
          this.title = '类目/新增'
          this.form.category_name = ''
          this.form.category_id = ''
          this.dialogFormVisible = true
        }
        this.dialogFormVisible = true
      },
      handleDelete(index, row) { //删除
        this.$confirm('此操作将永久删除该类目, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCategoryDel({
            category_id: row.category_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        })
      },
      submit() {
        this.$refs['form'].validate((valid) => {
          console.log(valid)
          if (valid) {
            if (this.form.category_id) {
              userInfoAPI.serviceCategoryEdit(this.form).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.getList()
                  this.dialogFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '编辑成功!'
                  });
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg
                  });
                }

              })
            } else {
              userInfoAPI.serviceCategoryAdd(this.form).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.getList()
                  this.dialogFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '新增成功!'
                  });
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg
                  });
                }

              })
            }
          }
        })
      },
      getList() {
        userInfoAPI.serviceCategoryList(this.query).then(res => {
          this.list = res.data.data.list || []
          this.query.total = res.data.data.page.count || 0
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      },
    }
  }
</script>
<style lang='scss' scoped>
  /deep/.el-dialog__title {
    color: #fff;
  }

  /deep/ .el-dialog__header {
    background-color: rgb(62, 62, 238);
  }

  /deep/ .el-dialog__headerbtn {
    i {
      color: #fff;
    }
  }

  .project {
    width: 100%;
    overflow: hidden;

    .project-2 {
      width: 100%;
      margin-left: 30px;
    }

    .project-1 {
      width: 100%;
      height: 30px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: left;

      .project-1-input {
        margin-top: 20px;
        margin-right: 20px;
        margin-left: 30px;
      }
    }

    .project-4 {
      width: 100%;
    }

    .project-3 {
      width: 100%;
      height: 30px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: left;

      .project-1-input {
        margin-top: 20px;
        width: 300px;
        margin-right: 20px;
      }
    }
  }
</style>
